import React, { useState, useEffect } from 'react';
import { client } from "../services/api";
import ActivityItem from './ActivityItem';
import ModalActivity from "./ModalActivity";
import SearchBar from './SearchBar';

function Activities() {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    client.getProjects()
      .then((resp) => setProjects(resp.data))
      .catch((err) => console.error(err.message));
  }, []);

  useEffect(() => {
    setFilteredProjects(projects.filter(project => 
      project.name.toLowerCase().includes(searchTerm.toLowerCase())
    ));
  }, [projects, searchTerm]);

  const handleSearchChange = (_searchTerm) => {
    setSearchTerm(_searchTerm);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDone = (newActivity) => {
    setProjects((prev) => [...prev, newActivity]);
  };

  return (
    <div className="activities">
      <div style={{ padding: 24 }}>
        <SearchBar title={`You have ${projects.length} active projects`} onSearchChange={handleSearchChange} />
      </div>
      <div className="content-wrapper">
        <button style={{ width: 'fit-content', padding: '10px 100px' }}onClick={() => setIsModalOpen(true)}>+ New Project</button>
        <ModalActivity isOpen={isModalOpen} onClose={handleCloseModal} onDone={handleDone}></ModalActivity>
      </div>
      <h5>Your Projects</h5>
      {filteredProjects.length === 0 && 'You have no available Projects.'}
      {filteredProjects.map((project) => (
        <div className="content-wrapper" key={project._id}>
          <ActivityItem project={project} />
        </div>
      ))}
    </div>
  );
}

export default Activities;